import React from 'react'

import imageOne from "../../resource/meditate/external-retreat/rules and regulations/1.png";
import imageThree from "../../resource/meditate/external-retreat/rules and regulations/2.png";
import imageFour from "../../resource/dana/gilanpasa/gilanpasa-afternoon/photo.jpeg";

const ExternalRules = () => {
  return (
    <div className="externalRules-page inside-pages dark-gold">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="mt-4 dark-gold font-main p-4">Bhaddeka Vihari Monastery and Retreat Center</h1>
<h1 className="mt-4 dark-gold font-second p-4">Rules and Regulations of External Retreats</h1>
      <div className="p-4 mt-5">
        <p className="h4 mt-5">
        The Bhaddeka Vihari Monastery and Meditation Centre is dedicated to providing a profound understanding of the Dhamma as taught by the Buddha, encouraging reflection on these teachings within one’s life. One of the services regularly offered is external retreats. Notifications for these retreats are shared through social media as well as the Bhaddeka Vihari Monastery and Meditation Centre website.
        </p>


        <h1 className="mt-4 dark-gold font-second">Retreat Guidelines</h1>
        <p className="h4 mt-5">
        All retreatants are required to adhere to the following guidelines while attending the retreat:
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Fruit Juices:</span>{" "}
          All fruit juices are permitted after noon, including those made from
          small to medium-sized fruits like mango, apple, banana, grapes, lime,
          orange, pomegranate, avocado, tangerine, guava, and various berries.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Noble Silence:</span>{" "}
          Maintain noble silence at all times during the retreat.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Prohibited Substances:</span>{" "}
          Smoking, alcohol, tobacco, and recreational drugs are strictly forbidden.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Modest Attire:</span>{" "}
          Dress modestly while on the retreat premises. Shorts, singlets, and revealing clothing are not permitted. Please wear white clothing to help maintain the tranquility of the retreat environment.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Mindful Presence:</span>{" "}
          Maintain calmness for yourself and others. Please switch off your mobile phone to avoid distractions.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; No Personal or Dhamma Discussions:</span>{" "}
          Personal matters and Dhamma discussions should be avoided. Do not offer Dhamma instructions to others.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Reading:</span>{" "}
          Reading books is not permitted unless advised by the teacher.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Environmental Considerations:</span>{" "}
          Do not adjust the lights or air conditioning in the meditation hall while meditating. If necessary, please make adjustments before the retreat begins or inform the organizer.
        </p>
        <p className="h4 mt-5 ">
          <span className="dark-gold text-bold">&#x2022; Cleanliness:</span>{" "}
          Assist in cleaning and tidying the meditation hall to restore it to its original condition at the end of the retreat.
        </p>

        <p className="h4 mt-5">These guidelines are intended for the benefit of all retreatants and to maintain the sanctity and harmony of the retreat space.</p>
        

        <h1 className="mt-6 dark-gold font-second">Donation</h1>
        <p className="h4 mt-5">While the teachings are offered freely, donations are welcome. They help cover expenses such as hall rental and other retreat-related costs.</p>

        <h3 className="h4 mt-5 text-center">Wishing you a peaceful, pleasant, and enriching retreat. May you find tranquility of mind and profound benefit in your practice.</h3>


        <h1 className="mt-6 dark-gold font-second">Eight Precepts</h1>
        <p className="h4 mt-5 ">1.	I undertake to abstain from killing beings</p>
        <p className="h4 mt-5 ">2.	I undertake to abstain from taking what is not given</p>
        <p className="h4 mt-5 ">3.	I undertake to abstain from any sexual activity</p>
        <p className="h4 mt-5 ">4.	I undertake to abstain from false, harmful speech</p>
        <p className="h4 mt-5 ">5.	I undertake to abstain from the use of intoxicants</p>
        <p className="h4 mt-5 ">6.	I undertake to abstain from eating after the midday meal</p>
        <p className="h4 mt-5 ">7.	I undertake to abstain from dancing, singing, music and watching 					entertainments*, and from using beautifying objects i.e. jewelry, perfume, 				cologne, fragrant antiperspirants, make-up etc.</p>
        <p className="h4 mt-5 ">8.	I undertake to abstain from indulging in high and luxurious seats and beds</p>

    </div>

    <div className="bottom-box mt-6">
          <img src={imageThree} alt="bottom-image" width={400} />
        </div>
    </div>
  )
}

export default ExternalRules